var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/data"
  }, /*#__PURE__*/React.createElement("g", {
    id: "data"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.4097 7.31934C13.4097 7.88648 12.95 8.34625 12.3828 8.34625C11.8157 8.34625 11.3559 7.88648 11.3559 7.31934C11.3559 6.75219 11.8157 6.29243 12.3828 6.29243C12.95 6.29243 13.4097 6.75219 13.4097 7.31934Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.586806
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.3828 3.94531C13.112 3.94531 13.7031 3.35419 13.7031 2.625C13.7031 1.89581 13.112 1.30469 12.3828 1.30469C11.6536 1.30469 11.0625 1.89581 11.0625 2.625C11.0625 3.35419 11.6536 3.94531 12.3828 3.94531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.3828 13.3345C13.112 13.3345 13.7031 12.7433 13.7031 12.0142C13.7031 11.285 13.112 10.6938 12.3828 10.6938C11.6536 10.6938 11.0625 11.285 11.0625 12.0142C11.0625 12.7433 11.6536 13.3345 12.3828 13.3345Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M2.99219 8.63965C3.72138 8.63965 4.3125 8.04852 4.3125 7.31934C4.3125 6.59015 3.72138 5.99902 2.99219 5.99902C2.263 5.99902 1.67188 6.59015 1.67188 7.31934C1.67188 8.04852 2.263 8.63965 2.99219 8.63965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0.4,
    d: "M11.796 7.75971C12.0366 7.75971 12.2361 7.5602 12.2361 7.31961C12.2361 7.07902 12.0366 6.8795 11.796 6.8795H7.54167V4.38558C7.54167 3.45843 7.93483 3.06527 8.86198 3.06527H11.796C12.0366 3.06527 12.2361 2.86575 12.2361 2.62516C12.2361 2.38457 12.0366 2.18506 11.796 2.18506H8.86198C7.44191 2.18506 6.66146 2.96551 6.66146 4.38558V6.8795H3.58073C3.34014 6.8795 3.14062 7.07902 3.14062 7.31961C3.14062 7.5602 3.34014 7.75971 3.58073 7.75971H6.66146V10.2536C6.66146 11.6737 7.44191 12.4542 8.86198 12.4542H11.796C12.0366 12.4542 12.2361 12.2546 12.2361 12.0141C12.2361 11.7735 12.0366 11.5739 11.796 11.5739H8.86198C7.93483 11.5739 7.54167 11.1808 7.54167 10.2536V7.75971H11.796Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/data.3eab5850cb7cceb3c2797888866d0987.svg";
export { ForwardRef as ReactComponent };